<template>
    <app-modal>
        <app-from-project></app-from-project>
    </app-modal>
</template>

<script>
    import Modal from '@/components/Dashboard/Modals/modal'
    import formProject from '@/components/CloudAdmin/forms/project.vue'
    export default {
        name: 'newProject',
        components: {
            'app-modal': Modal,
            'app-from-project': formProject
        },
        methods: {
            closeModal() {
                this.$root.$emit('closeModal')
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/CloudAdmin/modals/addNewProject.vue